import { userAtom } from '@/atoms/user.atom';
import FullPageLoader from '@/components/FullPageLoader';
import { buildOrgUrl, getPreferredOrgSlug } from '@/core/domain';
import { setToken } from '@/core/token';
import { useSetAtom } from 'jotai';
import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface iCallbackProps {}

const CallbackPage: FunctionComponent<iCallbackProps> = () => {
  const setUser = useSetAtom(userAtom);
  const navigate = useNavigate();
  const { t } = useTranslation('auth');

  const _handleRedirectToLogin = async () => {
    navigate('/auth/login', { replace: true });
  };

  const _handleCallback = async (code: string) => {
    try {
      const url = new URL(import.meta.env.VITE_ENDPOINT);
      url.pathname = '/callback';
      url.searchParams.set('code', code);
      const response = await fetch(url.toString(), {
        method: 'GET',
      });
      const data = await response.json();

      setToken(data.accessToken);
      setUser(data.user);
      const preferredSlug = getPreferredOrgSlug(data.organizationSlugs);
      if (preferredSlug) {
        if (window.location.hostname.startsWith(`${preferredSlug}.`)) navigate('/', { replace: true });
        else window.location.replace(buildOrgUrl(preferredSlug));
      } else {
        navigate('/', { replace: true });
      }
    } catch (error) {
      console.error(error);
      _handleRedirectToLogin();
    }
  };

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (code) _handleCallback(code);
    else _handleRedirectToLogin();
  }, []);

  return <FullPageLoader title={t('callback.loading')} subtitle={t('callback.loggingIn')} />;
};

export default CallbackPage;
